import React, { useEffect, useState } from 'react';
import { TApiParameter } from '../../../api/endpoints/Parameter';
import { TApiSubset } from '../../../api/endpoints/Subset';
import ParamSearch from './ParamSearch';
import * as Api from '../../../api';
import { TApiSet } from '../../../api/endpoints/Set';
import ProductSelectPanels from './SubsetPicker';
import { Card, Alert } from 'react-bootstrap';
import { selectParameters } from "../../../store/selectors/new/parameters";
import { useSelector } from "react-redux";

interface IProps {
  onChange: (subset: TApiSubset, params: Array<TApiParameter>) => void;
}

const SubsetSelect = (props: IProps) => {
  const { onChange } = props;
  const params = Object.values(useSelector(selectParameters));
  const [sets, setSets] = useState<Array<TApiSet>>([]);
  const [selectedParams, setSelectedParams] = useState<Array<TApiParameter>>([]);

  const onSubsetChange = (subset: TApiSubset) => {
    onChange(subset, selectedParams);
  }

  useEffect(() => {
    Api.Set.list().then(setSets);
  }, []);

  return (
    <Card className="subset-select">
      <Card.Body>
        <div className="margin-bottom-md">
          <ParamSearch params={params} value={selectedParams} onChange={setSelectedParams} isMulti />

          {selectedParams.length > 0 && (
            <div className="margin-top-sm">
              <Alert variant="info">
                The sets and subsets that do not meet any of the search parameters you specified are now
                greyed out, but are still clickable if you wish to select them.
              </Alert>
            </div>
          )}
        </div>

        <ProductSelectPanels sets={sets} params={selectedParams} onSubsetSelect={onSubsetChange} />
      </Card.Body>
    </Card>
  );
};

export default SubsetSelect;
